import type { SVGProps } from "react";

export default function ExportTableIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M12.0835 5.41626H14.5835M14.5835 5.41626H17.0835M14.5835 5.41626V7.91626M14.5835 5.41626V2.91626"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M2.08398 5.41683C2.08398 3.84548 2.08398 3.0598 2.57214 2.57165C3.06029 2.0835 3.84597 2.0835 5.41732 2.0835C6.98867 2.0835 7.77434 2.0835 8.26249 2.57165C8.75065 3.0598 8.75065 3.84548 8.75065 5.41683C8.75065 6.98818 8.75065 7.77385 8.26249 8.262C7.77434 8.75016 6.98867 8.75016 5.41732 8.75016C3.84597 8.75016 3.06029 8.75016 2.57214 8.262C2.08398 7.77385 2.08398 6.98818 2.08398 5.41683Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M11.251 14.5828C11.251 13.0115 11.251 12.2258 11.7391 11.7377C12.2273 11.2495 13.013 11.2495 14.5843 11.2495C16.1556 11.2495 16.9413 11.2495 17.4295 11.7377C17.9176 12.2258 17.9176 13.0115 17.9176 14.5828C17.9176 16.1542 17.9176 16.9398 17.4295 17.428C16.9413 17.9162 16.1556 17.9162 14.5843 17.9162C13.013 17.9162 12.2273 17.9162 11.7391 17.428C11.251 16.9398 11.251 16.1542 11.251 14.5828Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M2.08398 14.5828C2.08398 13.0115 2.08398 12.2258 2.57214 11.7377C3.06029 11.2495 3.84597 11.2495 5.41732 11.2495C6.98867 11.2495 7.77434 11.2495 8.26249 11.7377C8.75065 12.2258 8.75065 13.0115 8.75065 14.5828C8.75065 16.1542 8.75065 16.9398 8.26249 17.428C7.77434 17.9162 6.98867 17.9162 5.41732 17.9162C3.84597 17.9162 3.06029 17.9162 2.57214 17.428C2.08398 16.9398 2.08398 16.1542 2.08398 14.5828Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
    </svg>
  );
}
